// extracted by mini-css-extract-plugin
module.exports = {"selectNav":"Order_selectNav__3kJjj","selectMenu":"Order_selectMenu__1iIiV"};